import { useNavigate } from 'react-router-dom';

const GenresGrid = ({ collection }) => {
  
  const navigate = useNavigate();

  return (
    <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 w-full cursor-pointer">
      {collection.map((genre) => (
        <div
          key={genre.id}
          className="relative genre-card text-center rounded-lg"
          onClick={() => navigate(`/genre/${genre.name.toLowerCase().split(' ').join('')}`)}
        >
          <img
            src={genre.image}
            alt={genre.name}
            className="genre-image w-full h-auto rounded-lg"
          />
          <div className="absolute inset-0 flex items-center justify-center rounded-lg bg-black bg-opacity-50 hover:bg-opacity-60">
            <h3 className="text-3xl font-semibold">{genre.name}</h3>
          </div>
        </div>
      ))}
    </div>
  );
};

export default GenresGrid;